import { queryFollowProductList4R } from "@/api/product";
import constate from "constate";
import { useCallback, useEffect, useRef, useState } from "react";
import { useActivate } from "react-activation";

const useFollowProduct = () => {
  const [productList, setProductList] = useState<any[]>([]);
  const [hasNext, setHasNext] = useState<boolean>(false);
  const isLoading = useRef<boolean>(false);
  const currentPageNum = useRef<number>(1);
  const currentRequestId = useRef<number>(0);

  // 更新商品列表
  const updateProductList = useCallback(async (requestId: number) => {
    if (isLoading.current) {
      return;
    }
    isLoading.current = true;
    try {
      const params = {
        pageId: "Follow",
        pageNum: currentPageNum.current,
        pageSize: 20,
      };

      const res: any = await queryFollowProductList4R(params);

      if (requestId !== currentRequestId.current) {
        return;
      }

      const newProductList = res?.result || [];
      const hasMore = res?.hasNext || false;

      // 更新商品列表
      if (currentPageNum.current === 1) {
        setProductList(newProductList);
      } else {
        setProductList(prev => [...prev, ...newProductList]);
      }

      setHasNext(hasMore);

      if (hasMore) {
        currentPageNum.current += 1;
      }
    } catch (error) {
      console.error("更新关注商品列表失败", error);
    } finally {
      isLoading.current = false;
    }
  }, []);

  // 重置商品列表
  const resetProductList = useCallback(() => {
    currentPageNum.current = 1;
    currentRequestId.current = Math.floor(Math.random() * 10000000000);
    updateProductList(currentRequestId.current);
  }, [updateProductList]);

  // 加载更多
  const loadMore = useCallback(async () => {
    if (typeof currentPageNum.current === "undefined" || isLoading.current) {
      return;
    }
    currentRequestId.current = Math.floor(Math.random() * 10000000000);
    await updateProductList(currentRequestId.current);
  }, [updateProductList]);

  // 组件激活时重置列表
  useActivate(() => {
    resetProductList();
  });

  // 初始化时加载商品列表
  useEffect(() => {
    resetProductList();
  }, [resetProductList]);

  return {
    productList,
    hasNext,
    loadMore,
    resetProductList,
  };
};

export const [FollowProductProvider, useProductList, useHasNext, useLoadMore, useResetProductList] =
  constate(
    useFollowProduct,
    value => value.productList,
    value => value.hasNext,
    value => value.loadMore,
    value => value.resetProductList,
  );
